class AnnouncementMarquee extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.baseTrack = this.querySelector('.announcement-bar__track');
    if (!this.baseTrack) return;

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReducedMotion) {
      this.baseTrack.setAttribute('aria-hidden', 'false');
      return;
    }

    this.#build();

    this._resizeObserver = new ResizeObserver(() => this.#build());
    this._resizeObserver.observe(this);

    if (document.fonts && document.fonts.status !== 'loaded') {
      document.fonts.ready.then(() => this.#build());
    }
  }

  disconnectedCallback() {
    this._resizeObserver?.disconnect();
  }

  #build() {
    this.baseTrack.setAttribute('data-base', 'true');
    this.baseTrack.setAttribute('aria-hidden', 'false');
    this.querySelectorAll('.announcement-bar__track:not([data-base])').forEach(
      (el) => el.remove()
    );

    const viewport = this.closest('.announcement-bar__marquee-viewport') || this;
    const viewportWidth = viewport.getBoundingClientRect().width;
    const baseWidth = this.baseTrack.getBoundingClientRect().width;
    if (baseWidth <= 0 || viewportWidth <= 0) return;

    let repeats = Math.ceil((viewportWidth * 2) / baseWidth);
    if (repeats < 2) repeats = 2;
    if (repeats % 2 !== 0) repeats += 1;

    for (let i = 1; i < repeats; i++) {
      const clone = this.baseTrack.cloneNode(true);
      clone.removeAttribute('data-base');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      clone
        .querySelectorAll('a, button')
        .forEach((el) => el.setAttribute('tabindex', '-1'));
      this.appendChild(clone);
    }

    const pxPerSecond = Number(this.getAttribute('speed')) || 60;
    const distance = (baseWidth * repeats) / 2;
    const duration = distance / pxPerSecond;
    this.style.setProperty('--marquee-duration', `${duration}s`);
  }
}

if (!customElements.get('announcement-marquee')) {
  customElements.define('announcement-marquee', AnnouncementMarquee);
}